let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbkyD")).then(() => parcelRequire('1GfCc'));